/**
 * Product compare — localStorage list of up to 4 handles. Renders a
 * floating bar on any page with [data-compare-toggle] buttons, and a full
 * comparison table on /pages/compare (fetches each product's public JSON
 * client-side, no server round trip needed).
 */
(function () {
  'use strict';
  var KEY = 'wallz:compare';
  var MAX = 4;

  function getAll() { return WallZ.utils.getStorage(KEY, []); }
  function isSaved(handle) { return getAll().indexOf(handle) > -1; }

  function toggle(handle) {
    var list = getAll();
    var idx = list.indexOf(handle);
    if (idx > -1) {
      list.splice(idx, 1);
    } else {
      if (list.length >= MAX) list.shift();
      list.push(handle);
    }
    WallZ.utils.setStorage(KEY, list);
    updateButtons();
    renderBar();
    return idx === -1;
  }

  function updateButtons() {
    document.querySelectorAll('[data-compare-toggle]').forEach(function (btn) {
      btn.classList.toggle('is-active', isSaved(btn.dataset.productHandle));
    });
  }

  function renderBar() {
    var bar = document.querySelector('[data-compare-bar]');
    var list = getAll();
    if (!bar) return;
    if (!list.length) { bar.classList.remove('is-visible'); return; }
    bar.querySelector('[data-compare-count]').textContent = list.length;
    bar.classList.add('is-visible');
  }

  function ensureBar() {
    if (document.querySelector('[data-compare-bar]')) return;
    var bar = document.createElement('div');
    bar.className = 'compare-bar';
    bar.setAttribute('data-compare-bar', '');
    bar.innerHTML = '<div class="container compare-bar__inner">' +
      '<span class="compare-bar__text"><span data-compare-count>0</span> products selected to compare</span>' +
      '<a href="/pages/compare" class="btn btn--accent btn--sm">Compare Now</a>' +
      '<button type="button" class="btn btn--icon btn--outline-light btn--sm" data-compare-clear aria-label="Clear compare list">&times;</button>' +
      '</div>';
    document.body.appendChild(bar);
    bar.querySelector('[data-compare-clear]').addEventListener('click', function () {
      WallZ.utils.setStorage(KEY, []);
      updateButtons();
      renderBar();
    });
  }

  function renderComparePage() {
    var table = document.querySelector('[data-compare-table]');
    var empty = document.querySelector('[data-compare-empty]');
    if (!table) return;
    var handles = getAll();
    if (!handles.length) {
      table.hidden = true;
      if (empty) empty.hidden = false;
      return;
    }
    if (empty) empty.hidden = true;
    table.hidden = false;

    Promise.all(handles.map(function (h) { return fetch('/products/' + h + '.js').then(function (r) { return r.json(); }); }))
      .then(function (products) {
        var rowImage = '<tr><th>Product</th>' + products.map(function (p) {
          return '<td><img src="' + p.featured_image + '&width=200" alt=""><br><strong>' + p.title + '</strong>' +
            '<br><button type="button" class="compare-table__remove" data-compare-remove="' + p.handle + '">Remove</button></td>';
        }).join('') + '</tr>';
        var rowPrice = '<tr><th>Price</th>' + products.map(function (p) { return '<td>' + WallZ.utils.formatMoney(p.price) + '</td>'; }).join('') + '</tr>';
        var rowType = '<tr><th>Type</th>' + products.map(function (p) { return '<td>' + (p.type || '-') + '</td>'; }).join('') + '</tr>';
        var rowVendor = '<tr><th>Vendor</th>' + products.map(function (p) { return '<td>' + (p.vendor || '-') + '</td>'; }).join('') + '</tr>';
        var rowOptions = (products[0] && products[0].options || []).map(function (name, i) {
          return '<tr><th>' + name + '</th>' + products.map(function (p) {
            var vals = Array.from(new Set(p.variants.map(function (v) { return v.options[i]; })));
            return '<td>' + vals.join(', ') + '</td>';
          }).join('') + '</tr>';
        }).join('');
        var rowLink = '<tr><th></th>' + products.map(function (p) { return '<td><a href="' + p.url + '" class="btn btn--outline btn--sm">View</a></td>'; }).join('') + '</tr>';
        table.innerHTML = '<tbody>' + rowImage + rowPrice + rowType + rowVendor + rowOptions + rowLink + '</tbody>';
        table.querySelectorAll('[data-compare-remove]').forEach(function (btn) {
          btn.addEventListener('click', function () { toggle(btn.dataset.compareRemove); renderComparePage(); });
        });
      });
  }

  document.addEventListener('DOMContentLoaded', function () {
    ensureBar();
    updateButtons();
    renderBar();
    renderComparePage();

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-compare-toggle]');
      if (!btn) return;
      e.preventDefault();
      toggle(btn.dataset.productHandle);
    });
  });
})();
